import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["address", "sendForm", "sendToggle", "txList", "balanceValue", "copyBtn"]
  static values = { address: String, scanUrl: String }

  connect() {
    this.loadTxHistory()
  }

  copyAddress() {
    const addr = this.addressValue || this.addressTarget?.textContent?.trim()
    if (!addr) return
    navigator.clipboard.writeText(addr).then(() => {
      const btn = this.copyBtnTarget
      const orig = btn.textContent
      btn.textContent = '✓ 복사됨'
      setTimeout(() => btn.textContent = orig, 2000)
    })
  }

  toggleSendForm() {
    const form = this.sendFormTarget
    const isHidden = form.style.display === 'none' || !form.style.display
    form.style.display = isHidden ? 'block' : 'none'
    this.sendToggleTarget.textContent = isHidden ? '▲ 닫기' : '▶ SEND XOTN'
  }

  loadTxHistory() {
    if (!this.hasTxListTarget) return
    try {
      const txs = JSON.parse(localStorage.getItem('xton_tx_history') || '[]')
      this.renderTxHistory(txs)
    } catch(e) { /* ignore parse errors */ }
  }

  renderTxHistory(txs) {
    if (!this.hasTxListTarget) return
    if (txs.length === 0) {
      this.txListTarget.innerHTML = '<p style="color:#555577;font-family:\'JetBrains Mono\',monospace;font-size:0.75rem;text-align:center;padding:1rem;">거래 내역이 없습니다</p>'
      return
    }
    const scanBase = this.scanUrlValue || ''
    this.txListTarget.innerHTML = txs.slice(0, 10).map(tx => {
      const href = scanBase ? `${scanBase}/address/${tx.to}` : null
      const shortTo = `${tx.to?.slice(0,8)}...${tx.to?.slice(-6)}`
      const inner = `
        <div style="display:flex;justify-content:space-between;align-items:center;padding:0.6rem 0.25rem;">
          <div style="display:flex;align-items:center;gap:0.5rem;">
            <span style="font-family:'JetBrains Mono',monospace;font-size:0.65rem;color:#FF2E63;">▼ SEND</span>
            <span style="font-family:'JetBrains Mono',monospace;font-size:0.7rem;color:#8888AA;">${shortTo}</span>
          </div>
          <div style="display:flex;align-items:center;gap:0.5rem;">
            <span style="font-family:'JetBrains Mono',monospace;font-size:0.8rem;color:#FF2E63;">-${tx.amount} XOTN</span>
            ${href ? '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#555577" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>' : ''}
          </div>
        </div>`
      if (href) {
        return `<a href="${href}" target="_blank" rel="noopener noreferrer"
          style="display:block;text-decoration:none;border-bottom:1px solid rgba(57,255,20,0.06);
                 cursor:pointer;transition:background 0.15s;border-radius:2px;"
          onmouseover="this.style.background='rgba(57,255,20,0.04)'"
          onmouseout="this.style.background='transparent'">${inner}</a>`
      }
      return `<div style="border-bottom:1px solid rgba(57,255,20,0.06);">${inner}</div>`
    }).join('')
  }


  // ── 블록체인 송금 로딩 상태 토글 ──
  // 송금 폼 submit 시 버튼을 로딩 스피너로 교체하고,
  // 응답 도착 시 원래 상태로 복원한다.
  showSendLoading() {
    const btn = document.getElementById('vault-send-btn')
    const def = document.getElementById('vault-send-btn-default')
    const load = document.getElementById('vault-send-btn-loading')
    if (btn && def && load) {
      btn.disabled = true
      btn.classList.add('vault-send-loading')
      def.style.display = 'none'
      load.style.display = 'flex'
    }
  }

  hideSendLoading() {
    const btn = document.getElementById('vault-send-btn')
    const def = document.getElementById('vault-send-btn-default')
    const load = document.getElementById('vault-send-btn-loading')
    if (btn && def && load) {
      btn.disabled = false
      btn.classList.remove('vault-send-loading')
      def.style.display = 'flex'
      load.style.display = 'none'
    }
  }

  recordTx(event) {
    const form = event.target
    if (!form) return
    const formData = new FormData(form)
    const to = formData.get('to_addr')
    const amount = formData.get('amount')
    if (!to || !amount) return

    try {
      const txs = JSON.parse(localStorage.getItem('xton_tx_history') || '[]')
      txs.unshift({ to, amount, date: new Date().toISOString() })
      localStorage.setItem('xton_tx_history', JSON.stringify(txs.slice(0, 50)))
      this.renderTxHistory(txs)
    } catch(e) { /* ignore storage errors */ }
  }
}
